import c1 from "./images/c-1.png";
import parkLogo from "./images/parkLogo.png";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const globalMap: any = TMap as any;
export const appName = "shucheng";
// @ts-ignore
export const isYushan = appName === "yushan";
const configs = {
  shucheng: {
    // api: `https://apiv1.wxstores.cn`,
    api: `https://api.scjjkfq.com`,
    title: "舒城经济开发区智慧决策调度中心",
    parkDesc: ` 舒城经济开发区城关园区位于县城北部，规划面积13平方公里，是2006年省政府批准建立的省级开发区，现建成区达9平方公里，下辖7个村6个社区，是产城一体化园区、全国农产品加工创业基地、全省新型工业化童车童床示范基地、全省50家中小企业创业基地，现已进入国家级开发区培育期。
    全区上下将一以贯之紧紧围绕“服务合肥、发展舒城、等高对接、全面融入，晋升国家级开发区”的奋斗目标，积极融入合肥都市圈，全力推进园区经济社会高质量发展。`,
    mianji: `园区批复面积:13平方公里`,
    hangye: `产业定位： 装备制造、电子信息、农副食品加工`,
    parkLogo: parkLogo,
    parkLogoStyle: { height: "186px" },
    mapPos: [
      {
        name: "郑州",
        key: "sh",
        position: [113.608285, 34.757492],
      },
      {
        name: "济南",
        key: "hz",
        position: [117.099941, 36.653606],
      },
      {
        name: "合肥",
        key: "csj",
        position: [117.219432, 31.8251993],
      },
      {
        name: "上海",
        key: "nj",
        position: [121.452111, 31.24308],
      },
      {
        name: "武汉",
        key: "wh",
        position: [114.27819, 30.596903],
      },
      {
        name: "舒城",
        key: "sc",
        isMain: true,
        position: [116.963646, 31.482396],
      },
      // {
      //   name: "舒城经济开发区",
      //   key: "ys",
      //   position: [118.550572, 31.644232],
      // },
    ],
    zoom: 6.3,
    position: [116.963646, 31.482396],
    ellipseGeometry: [
      {
        styleId: "default",
        center: new globalMap.LatLng(31.482396, 116.963646),
        majorRadius: 443292.0115843598,
        minorRadius: 623292.83951097802,
      },
    ],
    shebei: [
      {
        icon: c1,
        title: "纬二路与龙潭南路东北角",
      },
      {
        icon: c1,
        title: "纬二路与龙潭南路东南角",
      },
      {
        icon: c1,
        title: "纬二路与龙潭南路西北角",
      },
      {
        icon: c1,
        title: "纬二路与龙潭南路西南角",
      },
    ],
    hjshebei: [],
    menuMap: {
      3: {
        title: "经济运行",
      },
    },
  },
  yushan: {},
};

export const appConfigs = configs[appName] as any;
